
<div class='back-to-dashboard' (click)="backToDashboard()">
    <mat-icon>arrow_back_ios</mat-icon>
    <span style='vertical-align:top;'>{{ 'service.back' | translate}}</span>
</div>
<app-loading size="0.5" class="loading-spinner" *ngIf="load else wrapper" color="var(--primary-sec-color)"></app-loading>
<ng-template #wrapper>
<div class="heading">
    {{ 'delivery.scheduleDelivery' | translate}}
    <ng-container *ngIf="!isUpdate && (customerDetails$ | async)?.firstName">
        {{ 'delivery.for' | translate}} {{(customerDetails$ | async)?.firstName |titlecase }} {{(customerDetails$ | async)?.lastName |titlecase }}
    </ng-container>
    <ng-container *ngIf="isUpdate && customerDataOnEdit?.firstName">
        {{ 'delivery.for' | translate}} {{customerDataOnEdit?.firstName |titlecase }} {{customerDataOnEdit?.lastName |titlecase }}
    </ng-container>
</div>
<div class="search-customer-wrapper container" style="padding-bottom: 3rem;">
    <mat-accordion multi>
        <mat-expansion-panel [expanded]="true">
            <mat-expansion-panel-header>
                <mat-panel-title>
                    {{ 'delivery.vehicleInformation' | translate}}
                </mat-panel-title>
                <mat-panel-description *ngIf="!appointmentId" class="form-status">
                    <span class="in-complete" *ngIf="!isVinValid || vehicleDetails.isInvalid  || vehicleDetails.isAlreadyBooked">{{ 'deliveryChecklist.formIncomplete' | translate }} </span>
                    <span [ngClass]="!enableSubmitButton ? 'statusLabel' : 'complete'" *ngIf="isVinValid && !vehicleDetails.isInvalid  && !vehicleDetails.isAlreadyBooked">{{ 'deliveryChecklist.formComplete' | translate }} <span *ngIf="showStatusLabel" [ngClass]="!enableSubmitButton ? 'statusLabel' : ''">({{ vehicleStatusLabel | translate}})</span></span>
                </mat-panel-description>
                <mat-panel-description class="form-status" *ngIf="appointmentId">
                    <span [ngClass]="!enableSubmitButton ? 'statusLabel' : 'complete'">{{ 'deliveryChecklist.formComplete' | translate }} <span *ngIf="showStatusLabel" [ngClass]="!enableSubmitButton ? 'statusLabel' : ''">({{ vehicleStatusLabel | translate}})</span></span>
                </mat-panel-description>
            </mat-expansion-panel-header>
                <span *ngIf="!appointmentId" class="select-vehicle-header">{{ 'delivery.selectVehicle' | translate}}</span>
                <form *ngIf="!appointmentId" class="search-form" [formGroup]="searchVinForm" (ngSubmit)="submitVinForm()">
                    <div  class="field-container">
                        <div class="field">
                            <label class="stock-label">{{ 'service.enterTheVin' | translate}}<span style="color: red">*</span></label>
                            <mat-form-field class="search-input" appearance="outline">
                                <input type="text" matInput [placeholder]="'service.enterThe17DigitVin' | translate" (input)="onSearchChange($event.target.value)" formControlName="vin" autocomplete="off" maxlength="300" required>
                                <mat-error
                                    *ngIf=" searchVinForm.controls.vin.errors?.pattern17DigitAndAlphaNumeric"
                                >{{searchVinForm.controls.vin.errors?.pattern17DigitAndAlphaNumeric | translate}}</mat-error>
                                <mat-error
                                    *ngIf=" searchVinForm.controls.vin.errors?.pattern17Digit"
                                >{{searchVinForm.controls.vin.errors?.pattern17Digit | translate}}</mat-error>
                                <mat-error
                                    *ngIf=" searchVinForm.controls.vin.errors?.patternAlphaNumeric"
                                >{{searchVinForm.controls.vin.errors?.patternAlphaNumeric | translate}}</mat-error>
                            </mat-form-field>
                            <div class="vin-error" style="font-size: 1.25rem;" *ngIf="vehicleDetails.isInvalid || vehicleDetails.isDealerDifferent">
                                {{ 'delivery.vehicleNotFound' | translate}}</div>
                            <div class="vin-error" *ngIf="vehicleDetails.isAlreadyBooked">{{ message | translate}} {{customerName}} {{appointment.appointmentStatus !== 'SavedForLater' ? ('delivery.deliveryOn' | translate) : ''}} {{appointment.appointmentStatus === 'Completed' ? date+'.' : date}} {{appointment.appointmentStatus === 'Completed' ? ('delivery.deliveryConfirmVin' | translate) : ''}}</div>
                            <div class="vin-error" *ngIf="!enableSubmitButton && !vehicleDetails.isDealerDifferent && vehicleDetails.isInvalidCategory">{{ 'delivery.deliveryContinueMessage' | translate}}</div>
                            <div class="vin-error" style="margin-top:0.5rem;"
                                *ngIf="vehicleDetails?.certificationStatus === 'CERTIFIED' && vehicleDetails?.isDealerDifferent && vehicleDetails?.make?.toUpperCase() !== 'LEXUS'">
                                {{ 'delivery.recertifyMessage' | translate}}
                            </div>
                        </div>
                        <div class="field buttons">
                            <button type="submit" class="save-btn">
                                <span>{{ 'searchCustomer.search' | translate}}</span>
                            </button>
                        </div>
                    </div>
                </form>
                <div class="search-customer-wrapper container">
                    <app-vehicle-delivery [vehicleDetails]='vehicleDetails' [showSplitter]="showSplitter"></app-vehicle-delivery>
                </div>
        </mat-expansion-panel>
    </mat-accordion>
</div>

<div class="container">
    <div [formGroup]='deliveryForm'>
        <div class="delivery-form">
            <mat-accordion multi>
            <div style="padding-bottom: 3rem;" class="">
                <mat-expansion-panel [expanded]="!showMandatoryMsgCI && isUpdate">
                    <mat-expansion-panel-header>
                        <mat-panel-title>
                            {{ 'otherTexts.customerInformation' | translate}}
                        </mat-panel-title>
                        <mat-panel-description class="form-status">
                            <span class="in-complete" *ngIf="!showMandatoryMsgCI">{{ 'deliveryChecklist.formIncomplete' | translate }} </span>
                            <span class="complete" *ngIf="showMandatoryMsgCI">{{ 'deliveryChecklist.formComplete' | translate }} </span>
                        </mat-panel-description>
                    </mat-expansion-panel-header>
                <app-contact-email-info formControlName="customer" (formEdited)="valuesChanges($event)" (isCIformValid)="isCIformValid($event)" [apptType]="apptType"></app-contact-email-info>
                </mat-expansion-panel>
            </div>

            <div style="padding-bottom: 3rem;">
                <mat-expansion-panel >
                    <mat-expansion-panel-header>
                        <mat-panel-title>
                            {{ 'otherTexts.appointmentLocation' | translate}}
                        </mat-panel-title>
                    </mat-expansion-panel-header>

                    <div *ngIf="isUpdate ? deliveryForm.value.transportationTypeCode : true">
                        <app-toggle-location *ngIf="hasRemoteLocation"
                        [allTransportOptions]="transportOptions$ | async"
                        [formControlName]="'transportationTypeCode'" [department]="aptType"
                        (click)="checkZipCodes(deliveryForm.value.remoteZipCode)">
                        </app-toggle-location>
                    </div>
    
                <ng-container *ngIf="deliveryForm.value.transportationTypeCode === 'REMOTE'">
                        <div style="text-align: center; font-size: 0.8rem;">{{ 'testDrive.pleaseEnterCustomerZipcodeToCheckTheDealer' | translate}}</div>
                        <div class="zip">
                            <mat-form-field appearance="outline">
                                <mat-label>{{ 'common.Zipcode' | translate}}</mat-label>
                                <input matInput required #zip [placeholder]="'common.Zipcode' | translate" formControlName="remoteZipCode"
                                    (input)="checkZipCodes(zip.value)" />
                                <mat-error>{{ 'service.sorryRemoteServicesAreNotAvailableTxt' | translate}}</mat-error>
                            </mat-form-field>
                            <div class="tick" [ngClass]="{'selected' : isValidRemoteZip}"></div>
                        </div>
                </ng-container>

                <app-customer-info formControlName="address" [location]="deliveryForm.value.transportationTypeCode" [department]="'sales'" (formEdited)="valuesChanges($event)"></app-customer-info>
            
                </mat-expansion-panel>
            </div>
            
            <app-trade-in-info formControlName="tradeIn" from='delivery' (formEdited)="valuesChanges($event)" [isTradeInEnabled]="settings?.portal?.enableTradeIn"></app-trade-in-info>
           
            <div style="padding-bottom: 3rem;">
                <mat-expansion-panel [expanded]="!AvailabilityComponent?.form?.valid && isUpdate">
                    <mat-expansion-panel-header>
                        <mat-panel-title>
                            {{ 'service.appointmentAvailability' | translate}}
                        </mat-panel-title>
                        <mat-panel-description class="form-status">
                            <span class="in-complete" *ngIf="!AvailabilityComponent?.form?.valid">{{ 'deliveryChecklist.formIncomplete' | translate }} </span>
                            <span class="complete" *ngIf="AvailabilityComponent?.form?.valid">{{ 'deliveryChecklist.formComplete' | translate }} </span>
                        </mat-panel-description>
                    </mat-expansion-panel-header>
                    
                    <app-availability *ngIf="languageId!=='' && isUpdate;else noEdit" class='app-availability' formControlName='availability'
                                [options]="availabilityOptions$ | async"
                                [isAvailabilityLoading]="enableSubmitButton ? (availabilityLoading$ | async) : false"
                                [availability]="availability$ | async" [apptType]="apptType"
                                [selectedTransport]="deliveryForm.value.transportationTypeCode"
                                [isEditMode]="isUpdate"
                                [customerLanguage]="languageId"
                                [showClearDateTimeBtn]="true"
                                [disableCalendar]="!enableSubmitButton"
                                [submitAllowed]="!enableSubmitButton"
                                (monthChanged)="onMonthChange($event)"
                                (formEdited)="valuesChanges($event)"
                                [appointmentId]="appointmentId"
                                [calenderMessage]="calenderMessage">
                            </app-availability>
                            <ng-template #noEdit>
                                <app-availability  class='app-availability' formControlName='availability'
                                    [options]="availabilityOptions$ | async"
                                    [isAvailabilityLoading]="enableSubmitButton ? (availabilityLoading$ | async) : false"
                                    [availability]="availability$ | async" [apptType]="apptType"
                                    [selectedTransport]="deliveryForm.value.transportationTypeCode"
                                    [showClearDateTimeBtn]="true"
                                    [disableCalendar]="!enableSubmitButton"
                                    [submitAllowed]="!enableSubmitButton"
                                    (monthChanged)="onMonthChange($event)"
                                    (formEdited)="valuesChanges($event)"
                                    [calenderMessage]="calenderMessage">
                                </app-availability>
                            </ng-template>
 
        
                </mat-expansion-panel>
            </div> 
            </mat-accordion>
        </div>
    </div>
</div>
<div id="delivery-sticky-footer">
    <div id="accept-terms">
        <span class="label">
          {{getDisclaimerText}}
        </span>
    </div>
    <div class='appointment-submit'>
        <div>
            <button class='submit' [class.submitting]="isSaveForLaterSubmitting" (click)='onSubmitSaveForLater()'
              [ngClass]="isValidSaveForLaterForm() ? 'enabled':'btn-disabled'" [disabled]="isSaveForLaterSubmitting">
                            <ng-container *ngIf="isSaveForLaterSubmitting; else deliverySaveForLaterLabel">
                                <app-loading loadingSymbol="dots" [text]="'testDrive.submitting' | translate" color="white" size=".7" [compact]="true"></app-loading>
                            </ng-container>
                            <ng-template #deliverySaveForLaterLabel>
                                <span>{{'delivery.saveForLater' | translate}}</span>
                            </ng-template>
            </button>
        </div>
        <div>
            <button class='submit' [class.submitting]="saveAndSendLink" (click)='triggerEmailAndSave()'
              [ngClass]="isValidSaveAndSendLinkForm() ? 'enabled':'btn-disabled'" [disabled]="saveAndSendLink">
                            <ng-container *ngIf="saveAndSendLink; else deliverySendLinkLabel">
                                <app-loading loadingSymbol="dots" [text]="'testDrive.submitting' | translate" color="white" size=".7" [compact]="true"></app-loading>
                            </ng-container>
                            <ng-template #deliverySendLinkLabel>
                                <span>{{'delivery.saveAndSendLink' | translate}}</span>
                            </ng-template>
            </button>
        </div>
        <div>
            <button class='submit' [class.submitting]="isSubmitting" (click)='submitTheAppointment()'
            [ngClass]="!isValidForm() || (isSubmitting || isSaveForLaterSubmitting) || (!enableSubmitButton) ? 'btn-disabled' : 'enabled' " [disabled]="isSubmitting || isSaveForLaterSubmitting">
                            <ng-container *ngIf="isSubmitting; else deliverySubmitLabel">
                                <app-loading loadingSymbol="dots" [text]="'testDrive.submitting' | translate" color="white" size=".7" [compact]="true"></app-loading>
                            </ng-container>
                            <ng-template #deliverySubmitLabel>
                                {{'testDrive.submit' | translate}}
                            </ng-template>
            </button>
        </div>
        
    </div>
    <div class='appointment-details' *ngIf="isValidForm()">
        {{ "testDrive.theAppointmentIsOn" | translate}} {{ getTranslation(deliveryForm.get('availability').value.appointmentStartDate | date : 'MMMM')}}
        {{deliveryForm.get('availability').value.appointmentStartDate | date : 'dd'}} {{'testDrive.aT' | translate }} {{deliveryForm.get('availability').value.timeSlotId }}
        {{ (deliveryForm.get('transportationTypeCode').value == 'REMOTE' ? ('testDrive.atRemoteLocation') :  ('testDrive.atDealershipLocation')) | translate }}
    </div> 
    <div class='appointment-details' *ngIf="isValidForm()">
        <span style="color: gray">{{ 'delivery.estimatedAppointmentDuration' | translate}}</span><span style="color:red">*</span><br>
        {{totalDuration}}
        <div class="disclaimer-text" *ngIf="deliveryForm.get('availability').value.timeSlotId && totalDuration">
            <span style="color:red"> *</span>
            <span style="color: gray">{{'otherTexts.theActualDurationMayVaryAtTheDealership' | translate}}</span>
        </div>
    </div>
</div>
</ng-template>
